/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'ai-mate.agent-header-banner-label': 'Баннер агента',
  'ai-mate.agent-list.all-agents-section-title': 'Все агенты',
  'ai-mate.agent-list.beta-lozenge-title': 'Бета-версия',
  'ai-mate.agent-list.change-owner-success-flag-description': 'Владелец агента {agentName} изменен на {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Владелец изменен',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Вы действительно хотите удалить агента? Это действие нельзя отменить.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Удалить агента {agentName}?',
  'ai-mate.agent-list.delete-agent-error': 'Не удалось удалить агента',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'При удалении агента произошла ошибка. Повторите попытку через некоторое время.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Не удалось удалить агента',
  'ai-mate.agent-list.delete-agent-error.agent-in-use':
    'В настоящее время агент используется. Повторите попытку позже.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Не удалось найти агента.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'Вы не можете удалять агентов, созданных другими пользователями. Обратитесь к владельцу агента.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Агент {agentName} удален',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Агент удален',
  'ai-mate.agent-list.development-section-title': 'Агенты разработки',
  'ai-mate.agent-list.load-more-button-loading': 'Загрузка других агентов…',
  'ai-mate.agent-list.load-more-button-ready': 'Еще',
  'ai-mate.agent-list.loading-agents': 'Загрузка агентов…',
  'ai-mate.agent-list.no-results': 'По запросу «{searchValue}» ничего не найдено',
  'ai-mate.agent-list.recommended-agents-section-title': 'Рекомендуемые',
  'ai-mate.agent-list.searching-agents': 'Поиск агентов…',
  'ai-mate.agent-list.templates-description':
    'Используйте эти шаблоны для создания собственного агента разработки. Выберите подходящий для ваших задач шаблон агента, нажмите «Использовать шаблон», а затем заполните запросы шаблона конкретными сведениями: укажите репозиторий, папку, язык и библиотеку. Создайте адаптированных агентов разработки, которые будут писать код для различных задач, проектов или репозиториев.',
  'ai-mate.agent-list.templates-lozenge-title': 'Шаблон',
  'ai-mate.agent-list.templates-title': 'Шаблоны написания кода',
  'ai-mate.agent-message.agent-not-found': 'Агент не найден',
  'ai-mate.agent-message.convo-title': 'Чат с агентом {agentName} запущен из встроенной интеллектуальной ссылки',
  'ai-mate.agent-message.copy-link': 'Копировать ссылку на агента',
  'ai-mate.agent-message.prompt': 'Запрос',
  'ai-mate.agent-message.prompt-placeholder': 'Введите сообщение агенту {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Отправить',
  'ai-mate.agent-message.view-profile': 'Просмотреть профиль',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Отмена',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Удалить',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Агент — {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Начать беседу с агентом {agentName}',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'URL-адрес скопирован',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': 'Копировать ссылку',
  'ai-mate.agent-profile-info.hidden-icon': 'Скрыто',
  'ai-mate.agent-profile-info.hidden-tooltip': 'Агент не будет отображаться в результатах поиска',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Отметить агента',
  'ai-mate.agent-selector.agent-not-found': 'Агент не найден',
  'ai-mate.agent-selector.default-agent-description':
    'Получайте ответы, генерируйте новые идеи и ускоряйте повседневную работу.',
  'ai-mate.agent-selector.default-agent-name': 'Чат',
  'ai-mate.browse-agents-view.close-button': 'Закрыть панель просмотра агентов',
  'ai-mate.profile-card-preview.actions-title': 'Действия',
  'ai-mate.profile-card-preview.agent-default-title': 'Агент',
  'ai-mate.profile-card-preview.agent-description-label': 'Описание',
  'ai-mate.profile-card-preview.agent-title-label': 'Заголовок',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Фразы для начала разговора',
  'ai-mate.profile-card-preview.empty-actions': 'Нет',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Нет',
  'ai-mate.profile-card-preview.empty-instructions': 'Нет',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Ничего не выбрано',
  'ai-mate.profile-card-preview.instructions-title': 'Инструкции',
  'ai-mate.profile-card-preview.knowledge-title': 'Знания',
  'ai-mate.profile-card-preview.regenerate-label': 'Создать «{fieldName}» повторно',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} — копия',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label':
    'Перетащите, чтобы изменить порядок',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Не удалось сохранить изменения',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Возникла неизвестная ошибка. Повторите попытку',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Агент с таким именем уже существует',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Удалить',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Сгенерировать фразы для начала разговора',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {Длина поля «{fieldName}» не должна превышать {maxLength,number} символ} few {Длина поля «{fieldName}» не должна превышать {maxLength,number} символа} many {Длина поля «{fieldName}» не должна превышать {maxLength,number} символов} other {Длина поля «{fieldName}» не должна превышать {maxLength,number} символа}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Далее',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Перезапустить',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Перейти к ручной настройке',
  'create-agent.owner-field.confirm-modal-cancel': 'Отмена',
  'create-agent.owner-field.confirm-modal-confirm': 'Да, продолжить',
  'create-agent.owner-field.confirm-modal-content':
    'Вы собираетесь сменить владельца агента на пользователя {name}. В результате этого действия вы больше не сможете редактировать агента и управлять им.',
  'create-agent.owner-field.confirm-modal-title': 'Вы потеряете доступ для редактирования',
  'create-agent.owner-field.owner-description': 'Этот пользователь может редактировать агента и управлять им.',
  'create-agent.owner-field.owner-label': 'Владелец',
  'rovo-chat.agent-card.deactivated-name': '{name} (деактивирован)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Слишком много запросов. Подождите немного.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Повторить попытку',
  'rovo-chat.browse-agents.all-agents-button': 'Все',
  'rovo-chat.browse-agents.close-button': 'Закрыть',
  'rovo-chat.browse-agents.create-agent-button': 'Создать',
  'rovo-chat.browse-agents.create-an-agent-button': 'Создать агента',
  'rovo-chat.browse-agents.create-button-disabled-tooltip': 'У вас нет права на создание агентов на этом сайте',
  'rovo-chat.browse-agents.created-by-label': '<text>от</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Агенты написания кода',
  'rovo-chat.browse-agents.favorite-agents-button': 'Избранное',
  'rovo-chat.browse-agents.favourited-agent-label': 'Избранный агент',
  'rovo-chat.browse-agents.modal-title': 'Обзор агентов',
  'rovo-chat.browse-agents.my-agents-button': 'Мои агенты',
  'rovo-chat.browse-agents.no-created-agents':
    'Похоже, вы еще не создали ни одного агента. Чтобы начать, скопируйте одного из существующих агентов или создайте нового агента с нуля.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Агентов пока нет',
  'rovo-chat.browse-agents.no-created-agents-header-no-permission': 'Вы не создали ни одного агента',
  'rovo-chat.browse-agents.no-created-agents-no-permission':
    'Для создания агентов Rovo на этом сайте необходимо, чтобы администратор предоставил вам права.',
  'rovo-chat.browse-agents.no-starred-agents':
    'Если у вас есть любимый агент или агент, которого вы часто используете, отметьте его для быстрого доступа.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Вы еще не отметили агента',
  'rovo-chat.browse-agents.search-input.placeholder': 'Поиск агентов',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Поиск шаблонов',
  'rovo-chat.browse-agents.see-all-agents-button': 'Просмотреть всех агентов',
  'rovo-chat.browse-agents.templates-button': 'Шаблоны',
  'rovo-chat.create-agent.actions-section-description':
    'Добавьте действия, чтобы агент мог выполнять задания в Jira, Confluence и Jira Service Management. <link>Что такое действия агента?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Добавить действия',
  'rovo-chat.create-agent.all-content-label': 'Все содержимое',
  'rovo-chat.create-agent.back-button': 'Назад',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Вы еще не создали агента. Хотите удалить его?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Отмена',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Да, удалить агента',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Вы действительно хотите отменить изменения, внесенные для этого агента?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Подтвердить',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Начнем с начала?',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Пользователи могут использовать эти фразы, чтобы начать чат с агентом. Если вам ничего не приходит в голову, мы можем сгенерировать их для вас.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Фразы для начала разговора',
  'rovo-chat.create-agent.create-agent-button': 'Создать',
  'rovo-chat.create-agent.ctions-section-title': 'Действия',
  'rovo-chat.create-agent.description-field-description':
    'Описание в профиле агента поможет пользователям узнать подробности о нем.',
  'rovo-chat.create-agent.description-field-label': 'Описание',
  'rovo-chat.create-agent.description-field-placeholder':
    'Кратко опишите своего агента (например, креативный писатель маркетинговых блогов)',
  'rovo-chat.create-agent.instructions-field-description':
    'Как должен вести себя агент? Что он может делать? <link>Подробнее о написании инструкций для агента</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Инструкции',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Настройте инструкции для агента',
  'rovo-chat.create-agent.intro-description-part-1':
    'Создайте агента со специальными знаниями, который будет отвечать на вопросы, писать и проверять контент, а также выполнять задания для ускорения вашей работы.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Если помощь не требуется, вы можете <bold>перейти к ручной настройке</bold>.',
  'rovo-chat.create-agent.intro-description-part-3': 'Иначе оставайтесь здесь, и мы создадим агента вместе.',
  'rovo-chat.create-agent.intro-step-1-content':
    'На основе того, что вы напишете, я создам инструкции для агента. Просто расскажите, для чего вы планируете использовать агента.',
  'rovo-chat.create-agent.intro-step-1-title': 'Опишите, для каких целей нужен агент',
  'rovo-chat.create-agent.intro-step-2-content':
    'Давайте вместе решим, каким будет имя и характер вашего агента. Расскажите, какой нужен агент — сопереживающий, прямолинейный или веселый.',
  'rovo-chat.create-agent.intro-step-2-title': 'Добавьте немного индивидуальности',
  'rovo-chat.create-agent.intro-step-3-content':
    'Нажмите <bold>Далее</bold>, чтобы проверить своего нового агента, добавить действия, знания и изображение профиля. Когда закончите, выберите <bold>Создать</bold>.',
  'rovo-chat.create-agent.intro-step-3-content-skills':
    'Нажмите <bold>Далее</bold>, чтобы проверить своего нового агента, добавить навыки, знания и изображение профиля. Когда закончите, выберите <bold>Создать</bold>.',
  'rovo-chat.create-agent.intro-step-3-title': 'Проверьте и создайте агента',
  'rovo-chat.create-agent.intro-title': '👋 Давайте создадим агента',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Все проекты',
  'rovo-chat.create-agent.jira-filter-placeholder-galaxia': 'Все разделы',
  'rovo-chat.create-agent.jsm-checkbox-label': 'Jira Service Management',
  'rovo-chat.create-agent.knowledge-field-description':
    'Определите область знаний агента, разрешив ему использовать только предоставленные вами источники',
  'rovo-chat.create-agent.knowledge-field-label': 'Знания',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Использовать только эти источники',
  'rovo-chat.create-agent.knowledge-select.object-resolver-label': 'Ссылки',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Предлагаемые',
  'rovo-chat.create-agent.manage-actions-button-label': 'Управление действиями',
  'rovo-chat.create-agent.name-field-description': 'Пользователи могут использовать его, чтобы найти агента.',
  'rovo-chat.create-agent.name-field-label': 'Имя',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error':
    'Произошла непредвиденная ошибка. Повторите попытку.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Здравствуйте! Я могу помочь вам создать пользовательского агента. Расскажите, что должен делать ваш агент?',
  'rovo-chat.create-agent.nl-input-field.input-label': 'Создать агента',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Введите сообщение',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Отправить',
  'rovo-chat.create-agent.page-title': 'Создание агента',
  'rovo-chat.create-agent.page-title-edit': 'Редактирование агента',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Поиск страниц',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Поиск разделов',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Все',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Бета-версия',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Отмена',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Закрыть',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Выбрав менее {count,number} действия, вы обеспечите оптимальную производительность} few {Выбрав менее {count,number} действий, вы обеспечите оптимальную производительность} many {Выбрав менее {count,number} действий, вы обеспечите оптимальную производительность} other {Выбрав менее {count,number} действия, вы обеспечите оптимальную производительность}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Сохранить',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Поиск в действиях',
  'rovo-chat.create-agent.select-action-modal-title': 'Добавление действий',
  'rovo-chat.create-agent.select-content-under-label': 'Выбрать контент в',
  'rovo-chat.create-agent.select-spaces-label': 'Выберите разделы',
  'rovo-chat.create-agent.selected-actions-label': 'Выбранные действия:',
  'rovo-chat.create-agent.unknown-owner': 'Неизвестен',
  'rovo-chat.create-agent.update-agent-button': 'Обновить',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Если вы продолжите, несохраненные изменения будут потеряны. Нажмите «Отмена», чтобы продолжить редактирование агента.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Продолжить и отменить изменения',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Отмена изменений',
  'rovo-chat.view-agent.about-label': 'Сведения',
  'rovo-chat.view-agent.actions-label': 'Действия',
  'rovo-chat.view-agent.all-knowledge-added': 'Все знания организации',
  'rovo-chat.view-agent.behaviour-label': 'Поведение',
  'rovo-chat.view-agent.beta-label': 'Бета-версия',
  'rovo-chat.view-agent.beta-tag': 'Бета-версия',
  'rovo-chat.view-agent.chat-to-agent-button': 'Чат с агентом',
  'rovo-chat.view-agent.close-button': 'Закрыть',
  'rovo-chat.view-agent.copy-behaviour-tooltip': 'Скопировать поведение',
  'rovo-chat.view-agent.copy-instructions-label': 'Копировать',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Копировать инструкции',
  'rovo-chat.view-agent.created-by-label': '<text>Автор:</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'Число избранных',
  'rovo-chat.view-agent.go-back-label': 'Назад',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Инструкции агентов Forge, созданных с помощью кода, скрыты в целях конфиденциальности.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Это закрытые инструкции',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Агенты Forge, созданные с помощью кода, не используют стандартные источники знаний',
  'rovo-chat.view-agent.instructions-label': 'Инструкции',
  'rovo-chat.view-agent.knowledge-label': 'Знания',
  'rovo-chat.view-agent.member-count':
    '{count, plural, one {{count,number} участник} few {{count,number} участника} many {{count,number} участников} other {{count,number} участника}}',
  'rovo-chat.view-agent.modal-title': 'Просмотреть агентов',
  'rovo-chat.view-agent.no-actions': 'Нет действий',
  'rovo-chat.view-agent.no-behaviour-placeholder': 'У агента нет специального поведения',
  'rovo-chat.view-agent.no-instruction-placeholder': 'У агента нет специальных инструкций',
  'rovo-chat.view-agent.no-knowledge-added': 'Нет знаний организации',
  'rovo-chat.view-agent.no-scenarios': 'Нет сценариев',
  'rovo-chat.view-agent.no-skills': 'Нет навыков',
  'rovo-chat.view-agent.no-teams': 'Не является участником команд',
  'rovo-chat.view-agent.open-chat-label': 'Открыть чат',
  'rovo-chat.view-agent.reactions-metadata-label': 'Число реакций',
  'rovo-chat.view-agent.rovo-agent-label': 'Агент Rovo',
  'rovo-chat.view-agent.scenarios-label': 'Сценарии',
  'rovo-chat.view-agent.skills-label': 'Навыки',
  'rovo-chat.view-agent.teams-label': 'Команды',
  'rovo-chat.view-agent.users-metadata-label': 'Число пользователей',
};
